import { createSlice } from '@reduxjs/toolkit';

const loadingBarSlice = createSlice({
  name: 'loadingBar',
  initialState: { count: 0 },
  reducers: {
    showLoading(state) {
      state.count += 1;
    },
    hideLoading(state) {
      state.count = Math.max(0, state.count - 1);
    },
  },
});

export const { showLoading, hideLoading } = loadingBarSlice.actions;
export default loadingBarSlice.reducer;
